export default "__VITE_ASSET__Bm2eFl5V__"